DatabaseEnableController.$inject= ['DatabaseService'];
export default function DatabaseEnableController(DatabaseService) {
    var ctrl = this;

    ctrl.$onChanges = function(changes) {
        if (changes) {
            ctrl.id = changes.id.currentValue;
            ctrl.load();
        }
    };

    ctrl.isSuccess = false;
    ctrl.isProcess = false;
    ctrl.isError = false;

    ctrl.load = function() {
        ctrl.isProcess = true;
        DatabaseService.get({id: ctrl.id}).$promise.then(function(response) {
            if (response.success) {
                ctrl.enable = response.data[0].enable;
                //ctrl.record_id = response.data[0].id;
                //console.log('record id', ctrl.record_id);
                ctrl.isSuccess = true;
            } else {
                ctrl.isError = true;
            }
            ctrl.isProcess = false;
        }, function(error) {
            console.log(error);
            ctrl.isError = error;
            ctrl.isProcess = false;
        });
    };

    ctrl.update = function() {
        ctrl.isProcess = true;
        //console.log('record id', ctrl.record_id);
        //DatabaseService.update({id: ctrl.record_id}, {enable: ctrl.enable}).$promise.then(function(response) {
        DatabaseService.update({id: ctrl.id}, {enable: ctrl.enable}).$promise.then(function(response) {
            if (response.success) {
                ctrl.isSuccess = true;
            } else {
                ctrl.isError = true;
            }
            ctrl.isProcess = false;
        }, function(error) {
            console.log(error);
            ctrl.isError = error;
            ctrl.isProcess = false;
        });
    }
}
